import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Badge,
  Col, FormFeedback, FormGroup, Input, Label, Button,
} from 'reactstrap';
import TheLayout from '../../layout/TheLayout';
import SuccessModal from '../Util/Modal/SuccessModal';
import FailureModal from '../Util/Modal/FailureModal';
import {
  updatePassword,
  clearResultFlg,
} from '../../redux/actions/auth';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const UpdatePw = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const [currentPw, setcurrentPw] = useState('');
  const [newPw, setnewPw] = useState('');
  const [confirmNewPw, setConfirmNewPw] = useState('');
  const [currentPwErr, setcurrentPwErr] = useState('');
  const [newPwErr, setnewPwErr] = useState('');
  const [confirmNewPwErr, setConfirmNewPwErr] = useState('');
  const isSuccess = useSelector((state) => state.auth.isSuccess, shallowEqual);
  const isFailure = useSelector((state) => state.auth.isFailure, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  });
  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }
  const closeResultModal = () => {
    dispatch(clearResultFlg());
  };

  const gotoHome = () => {
    dispatch(clearResultFlg());
    history.push('/');
  };

  const onSubmit = () => {
    let isInvalid = false;
    setcurrentPwErr('');
    setnewPwErr('');
    setConfirmNewPwErr('');
    if (currentPw === '') {
      setcurrentPwErr('現在パスワードを入力してください');
      isInvalid = true;
    }
    if (newPw === '') {
      setnewPwErr('新規パスワードを入力してください');
      isInvalid = true;
    }
    if (confirmNewPw === '') {
      setConfirmNewPwErr('新規パスワードを入力してください');
      isInvalid = true;
    }
    if (isInvalid) return;
    const param = {
      current_password: currentPw,
      new_password: newPw,
      new_password_confirmation: confirmNewPw,
    };
    dispatch(updatePassword(accessToken, param));
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>パスワード変更｜株式会社TERRA</title>
      </Helmet>
      <div className="updatePW" style={{ background: 'rgb(235, 244, 246)' }}>
        <div className="d-none d-lg-block">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb bg-transparent" style={{ color: 'rgb(181,189,185)', background: 'rgb(235, 244, 246)!important' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/mypage">マイページ</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>パスワード変更</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-2 p-md-5">
          <div
            className="information bg-white px-3 px-lg-5"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h4 className="row border-bottom py-2 pl-2" style={{ color: 'rgb(71,108,138)' }}>パスワード変更</h4>
            <div className="row border-bottom py-2">
              <Col form>
                <FormGroup row>
                  <Label for="currentPw" lg={4}>
                    現在パスワード
                    {' '}
                    <Badge color="danger">
                      必須
                    </Badge>
                  </Label>
                  <Col lg={8}>
                    <Input
                      invalid={currentPwErr !== ''}
                      onChange={(e) => {
                        setcurrentPwErr('');
                        setcurrentPw(e.target.value);
                      }}
                      maxLength="15"
                      minLength="8"
                      value={currentPw}
                      type="password"
                    />
                    <FormFeedback>{currentPwErr}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="newPw" lg={4}>
                    新規パスワード
                    {' '}
                    <Badge color="danger">
                      必須
                    </Badge>
                  </Label>
                  <Col lg={8}>
                    <Input
                      invalid={newPwErr !== ''}
                      onChange={(e) => {
                        setnewPwErr('');
                        setnewPw(e.target.value);
                      }}
                      maxLength="15"
                      minLength="8"
                      value={newPw}
                      type="password"
                    />
                    <FormFeedback>{newPwErr}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="confirmNewPw" lg={4}>
                    新規パスワード確認
                    {' '}
                    <Badge color="danger">
                      必須
                    </Badge>
                  </Label>
                  <Col lg={8}>
                    <Input
                      invalid={confirmNewPwErr !== ''}
                      onChange={(e) => {
                        setConfirmNewPwErr('');
                        setConfirmNewPw(e.target.value);
                      }}
                      maxLength="15"
                      minLength="8"
                      value={confirmNewPw}
                      type="password"
                    />
                    <FormFeedback>{confirmNewPwErr}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Button
                    style={{
                      background: 'transparent',
                      border: 'solid 1px rgb(71,108,138)',
                      color: 'rgb(71,108,138)',
                      height: '2rem',
                      lineHeight: '2rem',
                      borderRadius: '1rem',
                      padding: '0 40px',
                      float: 'right',
                      maxWidth: '300px',
                      margin: '3rem auto',
                    }}
                    onClick={onSubmit}
                  >
                    パスワード変更
                  </Button>
                </FormGroup>
              </Col>
            </div>
          </div>
          {/* 成功モーダル */}
          <SuccessModal
            isOpen={isSuccess}
            onclickOK={gotoHome}
            message="パスワードの変更が完了しました"
          />
          {/* 失敗モーダル */}
          <FailureModal
            isOpen={isFailure}
            onclickOK={closeResultModal}
            message="パスワードの変更に失敗しました。"
            detail="時間を置いてもう一度お試しください。"
          />
        </div>
      </div>
    </TheLayout>
  );
};

export default UpdatePw;
